import request from '@/router/axios';

// 检查运单合格率
export const postBuilderCheckWaybillExistDocIncomplete = (params) => {
  return request({
    url: '/chain/companyWaybillBuilderPage/postBuilderCheckWaybillExistDocIncomplete',
    method: 'post',
    data: params
  });
}; 